import {css} from '@emotion/react'
import LockIcon from '../../../images/startpage/icons/lock.svg'
import ShieldIcon from '../../../images/startpage/icons/shield.svg'
import WandIcon from '../../../images/startpage/icons/clear.svg'
import SpIcon from '../../../images/startpage/icons/app-icon.svg'

const translations = {
    en: {
        title: 'Why Choose Private AI',
        subtitle: 'The ultimate mobile AI experience for private and secure chats',
        features: [
            {
                icon: LockIcon,
                text: 'Chats are never tracked',
            },
            {
                icon: ShieldIcon,
                text: 'Chats are stored to your device',
            },
            {
                icon: SpIcon,
                text: 'Anonymous access to top AI models',
            },
            {
                icon: WandIcon,
                text: 'Clear chats with a single tap',
            },
        ],
    },
    de: {
        title: 'Warum Vanish wählen',
        subtitle: 'Das ultimative mobile KI-Erlebnis für private und sichere Chats',
        features: [
            {
                icon: LockIcon,
                text: 'Chats werden niemals verfolgt',
            },
            {
                icon: ShieldIcon,
                text: 'Chats werden auf Ihrem Gerät gespeichert',
            },
            {
                icon: SpIcon,
                text: 'Anonymer Zugang zu Top-KI-Modellen',
            },
            {
                icon: WandIcon,
                text: 'Chats mit einem Tippen verschwinden lassen',
            },
        ],
    },
    nl: {
        title: 'Waarom Vanish kiezen',
        subtitle: 'De ultieme mobiele AI-ervaring voor privé en veilige chats',
        features: [
            {
                icon: LockIcon,
                text: 'Chats worden nooit gevolgd',
            },
            {
                icon: ShieldIcon,
                text: 'Chats worden opgeslagen op uw apparaat',
            },
            {
                icon: SpIcon,
                text: 'Anonieme toegang tot top AI-modellen',
            },
            {
                icon: WandIcon,
                text: 'Laat chats verdwijnen met één tik',
            },
        ],
    },
}

// eslint-disable-next-line no-unused-vars
const Section1 = ({languageCode = 'en', experimentId, os, browser}) => {
    const text = translations[languageCode] || translations.en

    return (
        <section
            className="sp-section1"
            css={css`
                width: 100%;
                background: #000;
                padding: 56px 20px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
                position: relative;
                z-index: 1;
            `}
        >
            <div
                className="content-wrapper"
                css={css`
                    max-width: 400px;
                    width: 100%;
                    text-align: center;
                `}
            >
                <h2
                    css={css`
                        color: #EBECF7;
                        text-align: center;
                        leading-trim: both;
                        text-edge: cap;
                        font-family: 'Inter';
                        font-size: 28px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 40px;
                        letter-spacing: 0.5px;
                        margin: 0 0 26px 0;
                    `}
                >
                    {text.title}
                </h2>

                <p
                    css={css`
                        color: #EBECF7;
                        text-align: center;
                        leading-trim: both;
                        text-edge: cap;
                        font-family: 'Inter';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px; /* 150% */
                        letter-spacing: 0.048px;
                        margin: 0 0 30px 0;
                        max-width: 320px;
                        margin-left: auto;
                        margin-right: auto;
                        text-align: center;
                    `}
                >
                    {text.subtitle}
                </p>

                <div
                    className="features-grid"
                    css={css`
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 16px;
                        max-width: 400px;
                        width: 100%;

                        @media (max-width: 380px) {
                            gap: 12px;
                        }
                    `}
                >
                    {text.features.map((feature, index) => (
                        <div
                            key={index}
                            className="feature-item"
                            css={css`
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                text-align: center;
                                padding: 24px 16px;
                                border-radius: 20px;
                                border: 1px solid #38DDCC;
                                min-height: 120px;

                                @media (max-width: 380px) {
                                    padding: 20px 12px;
                                    min-height: 100px;
                                }
                            `}
                        >
                            <div
                                css={css`
                                    width: 45px;
                                    height: 45px;
                                    border-radius: 50%;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    margin-bottom: 4px;
                                `}
                            >
                                <feature.icon
                                    css={css`
                                        width: 100%;
                                        height: 100%;
                                    `}
                                />
                            </div>
                            <p
                                css={css`
                                    color: #f2f3fb;
                                    text-align: center;
                                    leading-trim: both;
                                    text-edge: cap;
                                    font-family: 'Inter';
                                    font-size: 14px;
                                    font-style: normal;
                                    font-weight: 400;
                                    line-height: 22px;
                                    letter-spacing: 0.3px;
                                    margin: 0;
                                `}
                            >
                                {feature.text}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Section1
